import { ExportProcessQuerySchema, ExportProcessResponseSchema } from './export-process.schema';
/**
 * Export Process Endpoint Contract
 * Exports a single process as a downloadable JSON or YAML file. The query flags
 * select which sections to include, whether references are populated or bare
 * ids, whether to embed org context, and the output format.
 */ export const exportProcessContract = {
    method: 'GET',
    path: '/api/v2/process/:id/export',
    description: 'Export a single process as a JSON or YAML file',
    requestSchema: ExportProcessQuerySchema,
    responseSchema: ExportProcessResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - org-managers only',
            404: 'Process not found'
        }
    }
};

//# sourceMappingURL=export-process.contract.js.map